import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { CurrencyWalletExpansionModule } from 'src/app/shared/components/currency-wallet-expansion/currency-wallet-expansion.module';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { ClickOutsideModule } from 'src/app/shared/directive/click-outside/click-outside.module';
import { LifeObserveModule } from 'src/app/shared/directive/life-observe/life-observe.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CurrencyWalletComponent } from './currency-wallet.component';

@NgModule({
  imports: [
    CommonModule,
    LifeObserveModule,
    EmptyModule,
    LoadingModule,
    ScrollbarModule,
    PipesModule,
    MatCheckboxModule,
    FormsModule,
    CustomizeFormModule,
    ClickOutsideModule,
    MatTabsModule,
    MatRadioModule,
    MatSlideToggleModule,
    CurrencyWalletExpansionModule,
  ],
  declarations: [CurrencyWalletComponent],
  exports: [CurrencyWalletComponent],
})
export class CurrencyWalletModule {}
